(function () {
  function getPanels(card) {
    return Array.from(card.querySelectorAll('[data-profile-panel]'));
  }

  function getButtons(card) {
    return Array.from(card.querySelectorAll('[data-profile-button]'));
  }

  function setActive(card, index) {
    if (!card) return false;

    const nextIndex = String(index);
    const panels = getPanels(card);
    const buttons = getButtons(card);
    const nextPanel = panels.find((panel) => panel.dataset.profilePanel === nextIndex);

    if (!nextPanel) return false;

    panels.forEach((panel) => {
      panel.classList.toggle('is-active', panel.dataset.profilePanel === nextIndex);
    });

    buttons.forEach((button) => {
      button.classList.toggle('is-active', button.dataset.profileButton === nextIndex);
    });

    card.dataset.activeProfilePanel = nextIndex;
    card.dispatchEvent(
      new CustomEvent('product-collection:panel-change', {
        bubbles: true,
        detail: {
          card,
          index: nextIndex,
          panel: nextPanel,
        },
      })
    );

    return true;
  }

  function initCard(card) {
    if (!card || card.dataset.productCollectionReady === 'true') return;
    card.dataset.productCollectionReady = 'true';

    const panels = getPanels(card);
    const buttons = getButtons(card);

    if (!panels.length || !buttons.length) return;

    card.productCollection = {
      getPanels: function () {
        return getPanels(card);
      },
      getButtons: function () {
        return getButtons(card);
      },
      getActivePanel: function () {
        return card.querySelector('[data-profile-panel].is-active');
      },
      setActive: function (index) {
        return setActive(card, index);
      },
    };

    buttons.forEach((button) => {
      button.addEventListener('click', function () {
        setActive(card, this.dataset.profileButton);
      });
    });

    const activePanel = card.querySelector('[data-profile-panel].is-active');
    const defaultPanel = card.dataset.defaultProfilePanel || panels[0].dataset.profilePanel;
    setActive(card, activePanel ? activePanel.dataset.profilePanel : defaultPanel);
  }

  function initAll() {
    document.querySelectorAll('[data-product-card]').forEach(initCard);
  }

  window.ProductCollectionSection = window.ProductCollectionSection || {};
  window.ProductCollectionSection.initCard = initCard;
  window.ProductCollectionSection.initAll = initAll;
  window.ProductCollectionSection.setActive = setActive;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
